export default __webpack_public_path__ + "static/media/trailer.ff6eeb38.svg";